import Authority from '@/enum/Authority'
import { useGlobalStore } from '@/store/hooks'
import { showAuthorityDialog } from '@/utils/dialog'
import { useHistory } from 'react-router'

/**
 * TODO: 需要重构，具体校验函数已放在globalStore下面
 */
const useAuthorityCheck = (authority: Authority) => {
    const { currentUser } = useGlobalStore()

    const history = useHistory()

    const hasAuthority = currentUser?.authorities?.includes?.(authority)

    const openAuthorityModal = () => {
        showAuthorityDialog(history, currentUser?.username, authority)
    }

    return { hasAuthority, openAuthorityModal }
}

export default useAuthorityCheck